import { schema } from 'normalizr'

export default [new schema.Entity('bans', {}, { idAttribute: 'ban_id' })]
